import angular from 'angular'
import { $unibase } from '../uni-base-module'

const perdidaSesionFailMsg =
  '                                                ' +
  'IMPORTANTE\n                                                -----------------\n\n' +
  'Ha habido un problema con la aplicación relativo a la sesión actual, y se ha intentado recuperar, ' +
  'pero también ha habido algún problema en el proceso.\n\n' +
  'Seguramente deberás volver a cargar la página o volver a entrar a la sección donde te encuentras.\n\n' +
  'Los datos que no hayas podido guardar se van a perder, desgraciadamente no podemos hacer mucho ahí.\n\n' +
  'Si crees que esto te pasa a menudo, por favor déjanos una incidencia, incluso nos vendría bien una incidencia en este caso. Gracias!'

const perdidaSesionFailReloginMsg =
  '                                                ' +
  'IMPORTANTE\n                                                -----------------\n\n' +
  'Ha habido un problema con la aplicación relativo a la sesión actual, y se ha intentado recuperar, ' +
  'pero también ha habido algún problema en el proceso.\n\n' +
  'Seguramente deberás volver a cargar la página o volver a entrar a la sección donde te encuentras.\n\n' +
  'Los datos que no hayas podido guardar se van a perder, desgraciadamente no podemos hacer mucho ahí.\n\n' +
  'Si crees que esto te pasa a menudo, por favor déjanos una incidencia, incluso nos vendría bien una incidencia en este caso. Gracias!'

const perdidaSesionOkMsg =
  'Ha habido un problema con la aplicación al realizar la última acción ' +
  "pero en principio se ha podido recuperar correctamente (nosotros le llamamos a esto 'pérdida de sesión').\n\n" +
  'Sin embargo, tendrás que volver a realizar la última acción. Si te vuelve a aparecer el mensaje es que hay algún problema más, ' +
  'por favor déjanos una incidencia.\n\n' +
  'Un posible caso de este error es que hayas estado tiempo (pero mucho!) sin cambiar de pantalla o trabajando en esta pantalla sin guardar datos. ' +
  'Si este no es el caso, o este mensaje te aparece a menudo (varias veces a la semana por ejemplo) déjanos también una incidencia. Gracias!'

export interface ISpinnerAction {
  off: () => void
  good: () => void
  aviso: (msg: string, title?: string, options?: ng.toastr.IToastOptions) => void
  error: (...args: string[]) => void
}
export interface ILoadingAction {
  good: (msg: string, title?: string, options?: ng.toastr.IToastOptions) => void
  goood: (msg: string, title?: string, options?: ng.toastr.IToastOptions) => void
  aviso: (msg: string, title?: string, options?: ng.toastr.IToastOptions) => void
  clear: () => void
}

// ErrorServicio.MsgApi
type TResponseData = {
  msg: string
  detail: string
  __v: string
}

type TResponseSpring = {
  error: string
  message: string
}

export class NotificacionService {
  loading: {
    show: (msg: string, title?: string, options?: ng.toastr.IToastOptions) => ng.toastr.IToast
    clear: () => void
    start: (msg: string, title?: string | null, options?: ng.toastr.IToastOptions) => ILoadingAction
    action: (msgLoading: string, msgOk: string, promise: any) => ng.IPromise<any> | Function
  }
  spinner: {
    active: boolean
    msg: string
    on: (msg?: string) => void
    off: () => void
    start(msg: string): ISpinnerAction
    action: (msg1: string, cb: ng.IPromise<any> | Function) => ng.IPromise<any> | Function
    loading: (msgLoading: string, msgOk: string, cb: ng.IPromise<any>) => ng.IPromise<any>
  }
  CHECK_API_URL: string
  URL_RELOGIN: string | null = null
  private _global_loading: ng.toastr.IToast | null
  trace: false

  constructor(
    private $log: ng.ILogService,
    private $q: ng.IQService,
    private $http: ng.IHttpService,
    private $window: ng.IWindowService,
    private $timeout: ng.ITimeoutService,
    private toastr: ng.toastr.IToastrService,
    private $animate: ng.animate.IAnimateService
  ) {
    this.CHECK_API_URL = '/xxxxxxxxxxxx/services/rest/priv/auth/check'
    this._global_loading = null

    // jsc : 20171110 : asociar el servicio al window para testing
    if (!(<any>$window).uniNotfService) (<any>$window).uniNotfService = this

    this.loading = {
      show: (msg, title?, options?) => {
        this._global_loading = this.toastr.info(msg, title, options)

        this.$animate.enabled(this._global_loading.el, false)

        return this._global_loading
      },
      clear: () => {
        this._global_loading && this.toastr.clear(this._global_loading)
        this._global_loading = null
      },
      start: (msg, _title?, options?) => {
        let action = new LoadingAction(msg, options)
        this._global_loading = action._itoast

        return action
      },
      /* aviso: (msg: string, title?: string, options?: ng.toastr.IToastOptions) => {
                          let action = new LoadingAction(msg)
                          this._global_loading = action._itoast
                      }, */
      action: (msgLoading, msgOk, cb: ng.IPromise<any> | Function) => {
        // tsvar info = this.loading.start(msgLoading)
        var info = this.loading.start(msgLoading, null, { timeOut: 30000 })

        // generar un defer a partir del resultado si es una función
        var $p = cb instanceof Function ? $q.when(cb()) : cb

        $p.then(
          () => {
            if (msgOk) {
              this.good(msgOk)
              this._trace('>>' + msgOk)
            }
          },
          (err) => {
            $log.info('NotifService: loading gestionando error ', err)

            this.aviso('Error en la aplicación')
          }
        ).finally(() => {
          info.clear()
        })

        return $p
      },
    }

    this.spinner = {
      active: false,
      msg: 'aaaa',
      on: (msg) => {
        if (msg) this.spinner.msg = msg

        this.spinner.active = true
      },
      off: () => {
        this.spinner.active = false
      },
      start: (msg: string) => {
        return new SpinnerAction(msg)
      },
      action: (msg1: string, cb: ng.IPromise<any> | Function) => {
        var info = this.spinner.start(msg1)

        // generar un defer a partir del resultado si es una función
        var $p = cb instanceof Function ? $q.when(cb()) : cb

        $p.catch((errr) => {
          $log.info('NotifService: spinner action gestionando error ', errr)
        }).finally(() => {
          this.spinner.off()
          info.off()
        })

        return $p
      },
      loading: (msgLoading: string, msgOk: string, $p: ng.IPromise<any>) => {
        this.loading.action(msgLoading, msgOk, $p)
        this.spinner.start('')

        $p.catch((errr) => {
          $log.info('NotifService: spinner loading gestionando error ', errr)
        }).finally(() => {
          this.spinner.off()
        })

        return $p
      },
    }

    const _notifService = this

    class SpinnerAction implements ISpinnerAction {
      constructor(msg: string) {
        _notifService.spinner.on(msg)
      }

      good() {
        _notifService.$timeout(() => {
          _notifService.spinner.off()
          _notifService._trace('>> spinner off')
        })
      }

      aviso(msg?: string, title?: string, options?: ng.toastr.IToastOptions) {
        _notifService.$timeout(() => {
          _notifService.spinner.off()
          _notifService.aviso(msg, title, options)
          _notifService._trace('>> spinner off')
        })
      }

      error = function () {
        let args = arguments

        _notifService.$timeout(() => {
          _notifService.spinner.off()
          _notifService.error(args[0], args[1], args[2])
        })
      }

      off() {
        this.good()
      }
    }

    class LoadingAction implements ILoadingAction {
      _itoast: ng.toastr.IToast

      constructor(msg: string, options?: ng.toastr.IToastOptions) {
        this._itoast = _notifService.loading.show(msg, undefined, options)
      }

      good(msg: string, title?: string, options?: ng.toastr.IToastOptions) {
        toastr.clear(this._itoast)
        $timeout(() => {
          _notifService.good(msg)
          _notifService._trace('>> ', msg)
        }, 20)
      }

      goood(msg: string, title?: string, options?: ng.toastr.IToastOptions) {
        toastr.clear(this._itoast)
        $timeout(() => {
          _notifService.goood(msg)
          _notifService._trace('>> ', msg)
        }, 0)
      }

      aviso(msg: string, title?: string, options?: ng.toastr.IToastOptions) {
        toastr.clear(this._itoast)
        $timeout(() => {
          _notifService.aviso(msg)
          _notifService._trace('>> ', msg)
        }, 20)
      }

      warning(msg: string, title?: string, options?: ng.toastr.IToastOptions) {
        toastr.warning(msg, title, options)
      }

      clear() {
        toastr.clear(this._itoast)
      }

      error(...args: unknown[]) {
        toastr.clear(this._itoast)

        _notifService.error(args[0], args[1] as any, args[2] as string)
      }
    }
  }

  private _trace(arg0: string, ...args: unknown[]) {
    this.trace && this._debug(arg0, args)
  }

  private _debug(arg0: string, ...args: unknown[]) {
    this.$log.debug('::' + arg0, args)
  }

  extraeStatus(errorArgs: unknown[] | null) {
    this.$log.debug('=== Status error', errorArgs)

    if (errorArgs && errorArgs.length > 2) {
      // el status es el segundo ??
      if (typeof errorArgs[1] == 'number') {
        return errorArgs[1] as number
      }
    }

    // undefined
  }

  __legacyAlert(msg: any) {
    // informar de un caso legacy,
    if (msg instanceof Object) {
      this._debug('********* \n\n     usando un alert sin gestionar el mensaje <<-- necesita gestión ', msg)

      try {
        console.trace()
      } catch (e) {}
    }

    window.alert('\n*********\n\n' + msg + '\n\n\n*********')
    this._trace('** ' + msg + '**')
  }

  gestionaPerdidaSesion(status: number | undefined, errorArgs: any) {
    // gestionar un 410 o un 401
    if (410 === status || 401 === status) {
      // se ha perdido la sesión, intentar reiniciar la sesión
      this.relogin(true).then(
        () => {
          // ha ido ok
          this.__legacyAlert(perdidaSesionOkMsg)
        },
        (error: unknown) => {
          this.__legacyAlert(this.URL_RELOGIN ? perdidaSesionFailReloginMsg : perdidaSesionFailMsg)

          if (this.URL_RELOGIN) {
            let w = window.open(this.URL_RELOGIN)

            if (!w) {
              console.log('No se puede abrir la ventana login')

              $('body').addClass('__sinsesion__')
            }
          }
        }
      )

      return true
    }

    return false
  }

  extraMsgApi(responseData: TResponseData) {
    if (responseData.__v === '001') return responseData.msg

    if (responseData.__v === '002') return responseData.msg + (responseData.detail ? ' : ' + responseData.detail : '')

    this.$log.error('Api desconocida: ' + responseData.__v, responseData)

    return '*'
  }

  /* ex spring es
           {
              "error": "Internal Server Error",
              "exception": "org.springframework.orm.ObjectRetrievalFailureException",
              "message": "No row with the given identifier exists: [#232791]; nested exception is org.hibernate.ObjectNotFoundException: No row with the given identifier exists: [#232791]",
              "path": "/unitec/api/er/em/232791",
              "status": 500,
              "timestamp": 1510146635439
          }
          */

  enhanceExcepcionSpring(responseData: TResponseSpring) {
    return responseData.message || responseData.error
  }

  // errorArgs es [ data, status, headers, config ]

  /* ex ErrorServicio es
           {
              "__v": "002",
              "detail": "Sector no encontrado en el catálogo buscando 'OFICINAS - DESPACHOS'",
              "msg": "Error en la aplicación"
          }
           */

  /** Este método debe devolver si se ha gestionado el error */
  notificaErrorServicios(deferred: unknown, errorArgs: unknown[] | null, msg: string): ng.IPromise<boolean> {
    var status = this.extraeStatus(errorArgs)
    this.$log.info('status error', status)

    // si hay pérdida de sesión, ya se ha informado del error
    if (this.gestionaPerdidaSesion(status, errorArgs)) return this.$q.when(true)

    if (errorArgs && errorArgs.length) {
      // puede ser un arguments, tiene más de 1 elemento

      // si el responseType es blob, al fallar seguirá siendo Blob
      return this.dataDesdeJson(errorArgs[0])
        .then((responseData) => {
          if (responseData && responseData.__v) {
            msg = msg + ':\n\n' + this.extraMsgApi(responseData)
          } else if (responseData && responseData.mensaje) {
            msg = msg + ':\n\n' + responseData.mensaje
          } else if (responseData && responseData.timestamp && responseData.exception) {
            // ResponseEntityHandler

            this.$log.error('Ex HttpResponse', responseData)

            // mensaje excepción Spring
            msg = msg + ':\n\n' + this.enhanceExcepcionSpring(responseData)
          } else if (errorArgs.length > 1) {
            // caso especial un HttpEntity
            if (417 === status && responseData.statusText) {
              // es un acceso denegado
              msg = msg + ':\n\n' + responseData.statusText
            }

            // no hay mensaje, caso especial
            if (403 === status) {
              // es un acceso denegado
              msg =
                msg +
                ':\n\n' +
                '*** Acceso denegado para esta operación **** \n\nVuelva a recargar la página para volver a introducir las credenciales de entrada'
            }
          }

          // mostrar el mensaje de error
          this.mostrarMensajeError(msg)

          // se ha gestionado
          return this.$q.when(true)
        })
        .catch(() => {
          // error al obtener los datos de respuesta

          // error al gestionar
          this.mostrarMensajeError(msg)

          // no se ha gestionado
          return this.$q.when(false)
        })
    }

    // si no se ha gestionado mostrar mensaje error
    this.mostrarMensajeError(msg)

    // se ha gestionado siempre???
    return this.$q.when(true)
  }

  private mostrarMensajeError(msg: string) {
    this.$log.error('>> (Error)', msg)

    // si hay un loading, limpiar mensaje
    this._global_loading && this.loading.clear()

    this.$timeout(() => {
      this.__legacyAlert(msg)
    })
  }

  /** si es Blob, intenta convertir desde Json, si no lo devuelve, asume que ya es objeto */
  private dataDesdeJson(dataOrBlob: any | Blob) {
    return dataOrBlob instanceof Blob ? this.blobToJson(dataOrBlob) : this.$q.when(dataOrBlob)
  }

  blobToJson(blob: Blob) {
    var defer = this.$q.defer()

    var fr = new FileReader()

    var reader = new FileReader()
    reader.onloadend = () => defer.resolve(angular.fromJson(reader.result as string))
    reader.onerror = () => defer.reject({ message: 'La respuesta no es correcta' })

    reader.readAsText(blob)

    return defer.promise
  }

  random() {
    return this.randomInternal(0)
  }

  randomInternal(i: number): string {
    var r = (Math.random() * Math.random()).toString(36)

    if (r.length < 4) return (i > 2 && '*****') || this.randomInternal(i + 1)
    else return r.substr(7)
  }

  checkPOST(witness: string) {
    return this.$http.post(
      this.CHECK_API_URL,
      {
        witness: witness,
      },
      { withCredentials: true }
    )
  }

  relogin(checkWithPOST: boolean) {
    var defer = this.$q.defer()

    var witness = this.random()

    this.$log.info(witness)

    // realizar un get para forzar la sesión
    this.$http
      .get(`${this.CHECK_API_URL}?witness=${witness}`, {
        withCredentials: true,
      })
      .then(
        (payload) => {
          // comprobar el witness y que tiene usuario

          // si se pide reconfirmación por POST
          if (checkWithPOST) {
            // recomprobar con un post
            this.checkPOST(witness).then(
              (payloadPOST) => {
                // reautenticación correcta

                defer.resolve()
              },
              (error) => {
                // error al reautenticar la sesión
                this.$log.error('Error al reautenticar', error)

                defer.reject(error)
              }
            )
          } else defer.resolve()
        },
        (error) => {
          this.$log.error('Error al regenerar la sesión', error)

          defer.reject(error)
        }
      )

    return defer.promise
  }

  setCheckUrl(u: string) {
    this.CHECK_API_URL = u
  }

  setUrlRelogin(url: string) {
    this.URL_RELOGIN = url
  }

  alert(msg: string) {
    this.__legacyAlert(msg)
  }

  error(deferred: unknown, errorArgs: unknown[] | null, msg: string): ng.IPromise<boolean> {
    return this.notificaErrorServicios(deferred, errorArgs, msg)
  }

  errorMsg(msg: string, title?: string): ng.IPromise<boolean> {
    return this.error(null, null, ((title && title + '\n\n\n') || '') + (msg || '(sin información al respecto)'))
  }

  error1() {} // ??????

  info(msg: string, title?: string, options?: ng.toastr.IToastOptions) {
    this.toastr.info(msg, title, options)
    this._trace('>> ', msg, title, options)
  }

  aviso(msg: string | undefined, title?: string, options?: ng.toastr.IToastOptions) {
    this.toastr.warning(msg || '', title, options)
  }

  good(msg: string, title?: string, options?: ng.toastr.IToastOptions) {
    this.toastr.success(msg, title, options || { timeOut: 350 })
    this._trace('>>', msg, title, options)
  }

  goood(msg: string, title?: string, options?: ng.toastr.IToastOptions) {
    let t = this.toastr.success(msg, title, options || { timeOut: 350 })

    this.$animate.enabled(t.el, false)
    this._trace('>>', msg, title, options)
  }

  testError(msg: string) {
    this.$timeout(() => {
      this.$log.info('testError en $timeout')
      throw new Error(msg)
    }, 100)

    throw new Error(msg)
  }
}

$unibase.service('NotifService', NotificacionService)
